import GET_ARTICLES from '../plugins/getArticles'
const [w,d,l] = [window,document,location]

const init = () => {
  
}

export default function BUSINESS () {
  // contentHeader
  const contentHeader = () => {
    const id = l.search ? l.search.match(/article=(\d+)/)[1] : '1'
    const renameHeader = (en,ja) => $('.mainImg .mainImgInner h2,h2.moduletitle').html(`<span>${en}</span><small>${ja}</small>`)
    switch(id){
      case '1': renameHeader('CONCEPT','事業コンセプト'); break
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8': renameHeader('BUSINESS OVERVIEW','事業内容'); break
    }
    const addTitle = (name,caption,desc) => $(`
      <div class="mainImgCaption">
        <span>${name}</span><strong>${caption}</strong><p>${desc}</p>
        </div>
    `).insertAfter('.mainImg .mainImgInner h2,h2.moduletitle')
    const addThumb = (image,text) => $(`
      <div class="mainImgThumb business-0${id}">
        <svg><use xlink:href="/asset/svg/sprite.symbol.svg#${image}"></use></svg>
        <span>${text}</span>
      </div>
      <div class="mainImgThumb-img business-0${id}"></div>
    `).insertAfter('.mainImg .mainImgInner h2,h2.moduletitle')
    switch(id){
      case '1': addTitle('［和助グループ経営理念］','高い志で地域創生に挑戦します。','少数精鋭・全員参加を基に社会の変化に対応し、<br class="hidden-small-up">成長を維持し、<br class="hidden-xsmall">社会へ貢献する<br class="hidden-small-up">プロフェッショナル集団を目指します。'); break
      case '2': addThumb('service-development','不動産開発'); break
      case '3': addThumb('service-investment','不動産投資'); break
      case '4': addThumb('service_solar','太陽光発電'); break
      case '5': addThumb('service-building','一般建築'); break
      case '6': addThumb('service-rental','マンション事業'); break
      case '7': addThumb('service-food','FCフード事業'); break
    }
  };
  d.addEventListener('DOMContentLoaded', contentHeader);
  d.addEventListener( 'DOMContentLoaded', init );
  $(w).on('load',function(){
    GET_ARTICLES('.p-business_nav[data-plugin="getArticles"]').done(() => {
      const url = l.search ? l.pathname+l.search : l.pathname+'?mode=detail&article=1'
      $('.p-business_nav[data-plugin="getArticles"]').currentMenu({mode:0,default:999,url});
    })
  });
}